import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { icon: "mdi-brightness-percent" }),
          _cache[0] || (_cache[0] = _createTextVNode("   Promocodes ")),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table, {
            headers: _ctx.headers,
            items: this.allPromocodes,
            "item-key": "promocode",
            "items-per-page": "10"
          }, {
            "item.discountPercentage": _withCtx(({ item }) => [
              (item.discountPercentage !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.discountPercentage), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, "   "))
            ]),
            "no-data": _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "custom-no-data" }, " No promocodes available. ", -1)
            ])),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}